import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'DialogConfirmDeletePlant',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog','ok-dialog'],
})
export default class DialogConfirmDeletePlant extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
      this.isDialogVisible = false;
  }
  handleOkDialog() {
    this.handleHideDialog();
    this.$emit('ok-dialog');
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }
}
